import React, { useState } from 'react';
import { Modal, Button, Input, message } from 'antd';
import { ModalBody, ModalContainer, InputLabel, Container, InputContainer } from './styles';
import { addTeam, updateTeam } from '../../utils/services/teamsAPI';
import { withTranslation } from 'react-i18next';
import { MANAGE_TEAM_MODAL, ADD_TEAM_MODAL, UPDATE_TEAM_MODAL} from '../../containers/UserSettingsPage/TranslationValues';

const NAMESPACE = ['MANAGE_TEAM_MODAL', 'ADD_TEAM_MODAL', 'UPDATE_TEAM_MODAL'];
const ADD_TEAM = 'ADD_TEAM_MODAL'
const UPDATE_TEAM = 'UPDATE_TEAM_MODAL'
const AddTeamModal = props => {
  const { onCancel, onSuccess, isEditTeam, selectedTeam, t } = props;
  const [teamName, setTeamName] = useState(isEditTeam ? selectedTeam.name : '');
  const [loading, setLoading] = useState(false);

  const handleKeyPress = e => {
    if (teamName && e.key === 'Enter') {
      onSave();
    }
  };

  const onSave = async () => {
    const payload = { name: teamName };
    if (isEditTeam) {
      payload.id = selectedTeam.id;
    }
    setLoading(true);
    const response = !isEditTeam ? await addTeam(payload) : await updateTeam(payload);
    if (response?.data || response.errors.length === 0) {
      let responseMsg =
        response.status === 'ResourceGroup Added Successfully'
        ? t(`${ADD_TEAM}:${ADD_TEAM_MODAL.ADD_NEW_TEAM_SUCCESS_MESSAGE.key}`, ADD_TEAM_MODAL.ADD_NEW_TEAM_SUCCESS_MESSAGE.value)
        : response.status === 'ResourceGroup Updated Successfully'
        ? t(`${UPDATE_TEAM}:${UPDATE_TEAM_MODAL.TEAM_UPDATED_SUCCESS_MESSAGE.key}`, UPDATE_TEAM_MODAL.TEAM_UPDATED_SUCCESS_MESSAGE.value)
        : response.status;
      message.success(responseMsg);
      onSuccess(payload);
    } else {
      response.errors[0].code === 791
      && message.error(t(MANAGE_TEAM_MODAL.EMPTY_OR_USED_TEAM_NAME_WARNING_MESSAGE.key, MANAGE_TEAM_MODAL.EMPTY_OR_USED_TEAM_NAME_WARNING_MESSAGE.value));
    }
    setLoading(false);
  };

  return (
    <Container onKeyDown={e => e.stopPropagation()} onKeyPress={handleKeyPress}>
      <Modal
        title={isEditTeam ? t(`${UPDATE_TEAM}:${UPDATE_TEAM_MODAL.UPDATE_TEAM_MODAL_TITLE.key}`, UPDATE_TEAM_MODAL.UPDATE_TEAM_MODAL_TITLE.value) : t(`${ADD_TEAM}:${ADD_TEAM_MODAL.ADD_TEAM_MODAL_TITLE.key}`, ADD_TEAM_MODAL.ADD_TEAM_MODAL_TITLE.value)}
        visible={true}
        maskClosable={false}
        centered
        onCancel={onCancel}
        footer={[
          <Button key="back" onClick={onCancel}>
            {t(MANAGE_TEAM_MODAL.CANCEL_TEAM_BUTTON.key, MANAGE_TEAM_MODAL.CANCEL_TEAM_BUTTON.value)}
          </Button>,
          <Button
            key="Add User"
            type="primary"
            disabled={!teamName}
            loading={loading}
            onClick={onSave}
          >
            {isEditTeam
              ? loading
                ? t(`${UPDATE_TEAM}:${UPDATE_TEAM_MODAL.UPDATING_NEW_TEAM_BUTTON.key}`, UPDATE_TEAM_MODAL.UPDATING_NEW_TEAM_BUTTON.value)
                : t(`${UPDATE_TEAM}:${UPDATE_TEAM_MODAL.UPDATE_NEW_TEAM_BUTTON.key}`, UPDATE_TEAM_MODAL.UPDATE_NEW_TEAM_BUTTON.value)
              : loading
              ? t(`${ADD_TEAM}:${ADD_TEAM_MODAL.ADDING_NEW_TEAM_BUTTON.key}`, ADD_TEAM_MODAL.ADDING_NEW_TEAM_BUTTON.value)
              : t(`${ADD_TEAM}:${ADD_TEAM_MODAL.ADD_NEW_TEAM_BUTTON.key}`, ADD_TEAM_MODAL.ADD_NEW_TEAM_BUTTON.value)}
          </Button>,
        ]}
      >
        <ModalBody>
          <ModalContainer>
            <InputContainer className="full-width">
            <InputLabel>{t(MANAGE_TEAM_MODAL.TEAM_NAME_LABEL.key, MANAGE_TEAM_MODAL.TEAM_NAME_LABEL.value)}</InputLabel>
              <Input
                size="large"
                placeholder={t(MANAGE_TEAM_MODAL.TEAM_NAME_PLACEHOLDER.key, MANAGE_TEAM_MODAL.TEAM_NAME_PLACEHOLDER.value)}
                name="teamName"
                value={teamName}
                onChange={e => setTeamName(e.target.value)}
                autoComplete={'off'}
              />
            </InputContainer>
          </ModalContainer>
        </ModalBody>
      </Modal>
    </Container>
  );
};

export default withTranslation(NAMESPACE)(AddTeamModal);
